import React from 'react'
import { Card, Col, Row, Table } from 'react-bootstrap'
import { Invoice, InvoiceLineAmountTypes } from '../../../../back-end/common/invoice'
import { XeroPayment } from '../../../../back-end/common/xeroPayment'
import { DateTime } from 'luxon'
import './invoiceCard.css'
import { XeroAccount } from '../../../../back-end/common/xeroAccount'
import { XeroTaxRate } from '../../../../back-end/common/xeroTaxRate'
import { dollarFormat, roundToTwo } from '../../utilities/format'

interface InvoiceCardProps {
	invoice: Invoice
	payments: XeroPayment[]
	accounts: XeroAccount[]
	taxRates: XeroTaxRate[]
}

const getTaxText = (taxStatus: InvoiceLineAmountTypes) => {
	if (taxStatus === 'Exclusive') {
		return 'Amounts are tax exclusive'
	}
	if (taxStatus === 'Inclusive') {
		return 'Amounts are tax inclusive'
	}
	if (taxStatus === 'NoTax') {
		return 'Amounts are not valid for tax'
	}
}

const InvoiceCard = ({ invoice, payments }: InvoiceCardProps) => {
	return (
		<Card className="mt-3 p-3">
			<Row className="mb-3">
				<Col></Col>
				<Col xs="auto">{getTaxText(invoice.lineAmountTypes)}</Col>
			</Row>
			<Table borderless>
				<thead>
					<tr>
						<th>Item / description</th>
						<th className="text-end">Price</th>
						<th className="text-end">Tax amount</th>
						<th className="text-end">Amount</th>
					</tr>
				</thead>
				<tbody>
					{invoice.lineItems?.map((li) => {
						// const account = accounts.find((a) => a.xeroID === li.xeroAccountXeroID)
						// const taxRate = getTaxRateFromType(account?.taxType, invoice.xeroOrg.version, taxRates)
						return (
							<React.Fragment key={li.invoiceLineID}>
								<tr className="cost-row account-row">
									<td>
										{li.description.split('\n').map((descriptionLine, index) => (
											<p key={index}>{descriptionLine}</p>
										))}
									</td>
									<td className="text-end">{dollarFormat(roundToTwo(li.unitAmount), true)}</td>
									<td className="text-end">{dollarFormat(roundToTwo(li.taxAmount), true)}</td>
									<td className="text-end">{dollarFormat(roundToTwo(li.lineAmount), true)}</td>
								</tr>
								{/* <tr className="account-row">
									<td colSpan={4}>
										Account: {account?.name} - Tax rate: {taxRate.label}
									</td>
								</tr> */}
							</React.Fragment>
						)
					})}
				</tbody>
			</Table>
			<Table borderless className="w-50">
				<tbody>
					<tr>
						<th>Subtotal</th>
						<td className="text-end">
							{dollarFormat(roundToTwo(['DRAFT', 'SUBMITTED'].includes(invoice.status) ? invoice.minimumTotal : invoice.subTotal), true)}
						</td>
					</tr>
					<tr>
						<th>Total GST</th>
						<td className="text-end">
							{dollarFormat(
								roundToTwo(
									['DRAFT', 'SUBMITTED'].includes(invoice.status)
										? invoice.amountDue === 0 && invoice.minimumTotal > 0
											? invoice.lineItems?.reduce((total, li) => (total += li.taxAmount), 0) || 0
											: invoice.amountDue - invoice.minimumTotal
										: invoice.totalTax
								),
								true
							)}
						</td>
					</tr>
					<tr className="total-row">
						<th>Total</th>
						<td className="text-end">
							{dollarFormat(
								roundToTwo(
									['DRAFT', 'SUBMITTED'].includes(invoice.status)
										? invoice.amountDue === 0 && invoice.minimumTotal > 0
											? invoice.lineItems?.reduce((total, li) => (total += li.lineAmount), 0) || 0
											: invoice.amountDue
										: invoice.total
								),
								true
							)}
						</td>
					</tr>
					{payments
						.sort((a, b) => Date.parse(a.date) - Date.parse(b.date))
						.map((payment) => (
							<tr key={payment.xeroPaymentID}>
								<th>Less payment - {DateTime.fromISO(payment.date).toFormat('d MMM yyyy')}</th>
								<td className="text-end">
									<strong>{payment.amount}</strong>
								</td>
							</tr>
						))}
					<tr className="due-row">
						<th>Amount due</th>
						<td className="text-end">
							<strong>{dollarFormat(roundToTwo(invoice.amountDue), true)}</strong>
						</td>
					</tr>
					<tr>
						<th>Written Off/Up</th>
						<td className="text-end">
							<strong>{dollarFormat(roundToTwo(invoice.writtenOff - invoice.writtenUp), true)}</strong>
						</td>
					</tr>
					<tr>
						<th>Written Off/Up %</th>
						<td className="text-end">
							<strong>
								{roundToTwo(
									((invoice.writtenOff - invoice.writtenUp) / (invoice.minimumTotal + invoice.writtenOff - invoice.writtenUp || 1)) * 100
								)}
								%
							</strong>
						</td>
					</tr>
					<tr>
						<th>Carry Forward</th>
						<td className="text-end">
							<strong>{dollarFormat(roundToTwo(invoice.carryForward))}</strong>
						</td>
					</tr>
				</tbody>
			</Table>
		</Card>
	)
}

export default InvoiceCard
